import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios'
import { makeStyles } from '@material-ui/styles';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1
  },
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1)
  },
  controlLabel: {
    width: 200
  },
  formControl: {
    marginTop: 20
  }
}));

const MoneyTypeData = props => {
  const classes = useStyles();
  const { className, financeuser, getMoneyTypeValue } = props;
  const [moneyTypeData, setMoneyTypeData] = useState([]);  // select data from database
  const [values, setValues] = useState([]);
  const [state, setState] = useState({});
  let source = axios.CancelToken.source();

  useEffect(() => {
    fetchData();
    getFinanceUser(financeuser);
    return () => {
      source.cancel();
    };
  }, [financeuser]);

  const fetchData = async () => {
    const url = 'https://eslip.snru.ac.th/backend/api/moneytype';
    try {
      const result = await axios(url, {
        cancelToken: source.token
      });
      setMoneyTypeData(result.data.data);
    } catch (error) { }
  };

  const getFinanceUser = async person => {
    let obj = {};
    let obj2 = {};
    const url = 'https://eslip.snru.ac.th/backend/api/financeUser/' + person.value;
    try {
      const response = await axios.get(url, {
        cancelToken: source.token
      });
      response.data.data.map(element => {
        obj = { ...obj, [element.money_type_id]: true }
        obj2 = { ...obj2, [element.money_type_id]: element.money_type_id.toString() }
      });
      setState({ ...state, ...obj });
      const result = Object.values(obj2);

      setValues(result);
      getMoneyTypeValue(result);
    } catch (error) { }
  }

  const handleChange = name => event => {
    setState({ ...state, [name]: event.target.checked });
    const index = values.indexOf(event.target.value);
    (event.target.checked) ? (values.push(event.target.value)) : (values.splice(index, 1))
    getMoneyTypeValue(values);
  };

  const moneytypes1 = moneyTypeData.filter((moneytype) => {
    return moneytype.income_type_id === 1
  })

  const moneytypes2 = moneyTypeData.filter((moneytype) => {
    return moneytype.income_type_id === 2
  })

  return (
    <div className={classes.root}>
      <FormControl component="fieldset">
        <FormLabel component="legend"><h3>รายการได้</h3></FormLabel>
        <FormGroup aria-label="position" name="position" row>
          {
            moneytypes1.map((moneytype, i) =>
              <FormControlLabel key={i} className={classes.controlLabel}
                control={
                  <Checkbox
                    checked={state[moneytype.money_type_id]||false}
                    onChange={handleChange(moneytype.money_type_id)}
                    value={moneytype.money_type_id}
                    color="primary"
                  />
                }
                label={moneytype.money_type_name}
              />)
          }

        </FormGroup>
        <FormLabel component="legend" className={classes.formControl}><h3>รายการหัก</h3></FormLabel>
        <FormGroup aria-label="position" name="position" row>
          {
            moneytypes2.map((moneytype, i) =>
              <FormControlLabel key={i} className={classes.controlLabel}
                control={
                  <Checkbox
                    checked={state[moneytype.money_type_id]||false}
                    onChange={handleChange(moneytype.money_type_id)}
                    value={moneytype.money_type_id}
                    color="primary"
                  />
                }
                label={moneytype.money_type_name}
              />)
          }
        </FormGroup>
      </FormControl>
    </div>
  );
};

MoneyTypeData.propTypes = {
  className: PropTypes.string,
  moneytype: PropTypes.object,
  financeuser: PropTypes.object,
  getMoneyTypeValue: PropTypes.func
};

export default MoneyTypeData;
